import React, {useMemo} from "react";
import {useTooltip} from "@widgets/tooltip/TooltipProvider";

type Props = {
    date: string,
};

const DateFormatter = ({date}: Props) => {
    const {applyTooltip} = useTooltip();
    const formattedDate: string = useMemo(
        () => new Date(date).toLocaleDateString(),
        [date]);
    const formattedDateTime: string = useMemo(
        () => new Date(date).toLocaleString(),
        [date]);

    return (
        <div
            className={"w-fit inline cursor-help"}
            {...applyTooltip(formattedDateTime)}
        >
            {formattedDate}
        </div>
    );
};

export default DateFormatter;